<template>
  <DetailsAccordion
    :error-description="i18n(translations.errorDescription)"
    :status
    @refresh="refresh"
  >
    <template #icon>
      <IconAttachment />
    </template>
    <template #title>
      <div class="flex items-center gap-8">
        {{ i18n(translations.title) }}
      </div>
    </template>
    <template #description>
      <span data-test="description">
        {{
          i18n(translations.description, {
            count: attachmentsByDate?.metadata.count ?? 0,
          })
        }}
      </span>
    </template>
    <template #body>
      <p v-if="attachmentsByDate?.content.length === 0">
        {{ i18n(translations.noAttachmentText) }}
      </p>
      <ol v-else class="divide-static-default-low space-y-24 divide-y">
        <li
          v-for="day in attachmentsByDate?.content"
          :key="day.date"
          class="pt-24 first:pt-0"
          data-test="attachments-for-one-day"
        >
          <p class="text-static-default-low body-2 mb-12">
            {{ i18n.date(new Date(day.date)) }}
          </p>

          <ol class="grid grid-cols-1 gap-12 lg:grid-cols-2">
            <li v-for="attachment in day.files" :key="attachment.id">
              <RevDocument
                v-if="attachment.name && attachment.url"
                class="w-full"
                :name="attachment.name"
                :url="attachment.url"
              />
            </li>
          </ol>
        </li>
      </ol>
    </template>
  </DetailsAccordion>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDocument } from '@ds/components/Document'
import { IconAttachment } from '@ds/icons/IconAttachment'

import { useOrderlineDetails } from '~/scopes/customer-care/pages/request/composables/useOrderlineDetails'

import DetailsAccordion from '../DetailsAccordion/DetailsAccordion.vue'

import translations from './Attachments.translations'

const i18n = useI18n()

const {
  attachments: { data: attachmentsByDate, status, refresh },
} = useOrderlineDetails()
</script>
